import axios from 'axios'

const UPDATE_ORGANIZATIONS = 'UPDATE_ORGANIZATIONS'

export default {
    namespaced: true,

    state: {
        organizations: [],
    },

    getters: {
        allOrganizations(state) {
            return state.organizations
        },
    },

    mutations: {
        [UPDATE_ORGANIZATIONS](state, { organizations }) {
            state.organizations = organizations
        },
    },

    actions: {
        refreshOrganizations({ commit, getters }) {
            return axios.get(`/organizations/all`).then(({ data }) => {
                commit(UPDATE_ORGANIZATIONS, { organizations: data })
            })
        },
    },
}
